import APIServer from './APIServer'
import UtilsManager from '../managers/UtilsManager'

export default class EventAPI extends APIServer {

	constructor(auth = null) {
		super(auth)
		this.utilsManager = new UtilsManager()
	}

	setAuth(auth) {
		super.setAuth(auth)
	}

	async getEvent(eventId, expansions = "tag", callback, errorhandler) {
		const eventUrl = '/events/' + eventId + `?expansions=${expansions}`;
		return await super.get(eventUrl, callback, errorhandler)
	}


	async getEventsV2({ zone = null, page = 1, pageSize = 10, startDate = null, endDate = null, excludeIds = null, orderBy = null, category = null, expansions=null} = {}) {
		var url = "/v2/event"
		const params = this.getParams({
			category: category, orderBy: orderBy, exclude_ids: excludeIds, expansions: expansions
		})

		params.push({zone_key: zone}, {page: page}, {page_size: pageSize}, {api_key: process.env.etaEventApiKey});

		if (startDate) { 
			params.push({start_date: startDate})
		}
		if (endDate) { 
			params.push({end_date: endDate})
		}

		url += this.utilsManager.combineParamsV2(params)
		return await super.get(url)
	}

	async getUpcomingEvents(zone, { category = null, limit = null, offset = null, start = null, end = null, rank = null, exclude_ids = null,
		orderBy = null, community = null, hasRoom = false, search = null, cost = null, expansions = "tag", venueId = null, venueName = null } = {}) {
		var url = '/upcoming_events'
		if (zone !== null && zone !== undefined) {
			url += '/' + zone
		}

		const params = this.getParams({
			category: category, limit: limit, offset: offset, start: start, end: end, rank: rank, exclude_ids: exclude_ids,
			orderBy: orderBy, community: community, hasRoom: hasRoom, search: search, cost: cost, expansions: expansions, venueId: venueId, venueName: venueName
		});

		url += this.utilsManager.combineParamsV2(params)

		return await super.get(url)
	}

	async getUpcomingFeatured(zone) {
		var url = '/upcoming_featured'
		if (zone !== null && zone !== undefined) {
			url += '/' + zone
		}
		return await super.get(url)
	}

	async createEvent(event) {
		return await super.post('/event', event)
	}

	async createTicketGroup(tickets) {
		return await super.post('/ticket_group', { tickets: tickets })
	}

	async bookTickets(ticketBookInfo) {
		return await super.post('/ticket', ticketBookInfo)
	}

	async createEvent(eventInfo) {
		return await super.post('/event', eventInfo)
	}

	// Deprecated. Use FileAPI.uploadMedia instead.
	async uploadEventMedia(event_id, file, media_type = "photo") {
		const url = '/event/' + event_id + '/media'
		const data = new FormData()
		if (media_type == "video") {
			data.append('video', file)
			data.append('name', 'vid.mp4')
			data.append('type', media_type)
		} else {
			data.append('photo', file)
			data.append('name', 'pic.jpg')
		}
		return await super.uploadMedia(url, data)
	}

	async getOrganizerEvents() {
		return await super.get('/organizer/my_events')
	}

	async getOrganizerEventDetail({ id, version = null }) {
		var url = '/organizer/event/' + id
		const params = []

		if (version !== null) {
			params.push({
				title: 'version',
				value: version
			})
		}

		url += this.utilsManager.combineParams(params)

		return await super.get(url)
	}

	async updateEvent(eventId, eventBody) {
		return await super.post('/event/' + eventId, eventBody)
	}

	async updateEventSetting(eventId, data) {
		return await super.post('/event/' + eventId + "/setting", data)
	}

	async getOrder(orderId) {
		return await super.get('/order/' + orderId)
	}

	async publishEvent(eventId, publication_body) {
		return await super.post('/event/' + eventId + "/publish", publication_body)
	}

	async sendMonetizationCompletion(data, monetizationId) {
		return await super.post('monetize/complete' + monetizationId)
	}

	async getEventAnalytics(eventId) {
		return await super.get('/analytics/event/' + eventId)
	}

	async submitEventbriteEvent(identifier) {
		const body = {
			event_identifier: identifier,
			event_type: 'eventbrite',
			name: "event_" + identifier
		}

		return await super.post('/outside_event', body)
	}

	async connectStripeAcc(code) {
		const data = { code: code }
		return await super.post('/connect_stripe', data)
	}


	getParams({ category = null, limit = null, offset = null, start = null, end = null, rank = null, exclude_ids = null,
		orderBy = null, community = null, hasRoom = false, search = null, cost = null, expansions = "tag", venueId = null, venueName = null } = {}) {
		const params = []
		if (category !== null) {
			params.push({
				category: category
			})
		}

		if (limit !== null) {
			params.push({
				limit: limit
			})
		}

		if (offset !== null) {
			params.push({
				offset: offset
			})
		}

		if (start !== null) {
			params.push({
				start: start
			})
		}

		if (end !== null) {
			params.push({
				end: end
			})
		}

		if (rank !== null) {
			params.push({
				min_rank: rank
			})
		}

		if (exclude_ids !== null) {
			params.push({
				exclude_ids: exclude_ids
			})
		}

		if (orderBy !== null) {
			params.push({
				order_by: orderBy
			})
		}

		if (community) {
			params.push({
				community: community
			})
		}

		if (hasRoom === true) {
			params.push({
				has_room: hasRoom
			});
		}
		if (search !== null) {
			params.push({
				search: search
			})
		}
		if (cost !== null) {
			params.push({
				cost: cost
			})
		}

		if (expansions) {
			params.push({
				expansions: expansions
			})
		}

		if (venueId) {
			params.push({
				venue_id: venueId
			})
		}
		if (venueName) {
			params.push({
				venue_name: venueName
			})
		}
		return params;
	}
}

